import React from "react";

import { Chip, Stack } from "@mui/material";
import { QueryManager } from "components/reports";
import { useClientSelector } from "store";

import { ClientReportSnapshot } from "./ClientReportSnapshot";

export const ReportingTab: React.FC = () => {
  const client = useClientSelector();
  const clientId = client?.id;

  // We're already inside a client's report (requests carry client_id), so the Clients filter is
  // shown as a preselected, disabled chip — it can't be changed here.
  const clientChip = client ? (
    <Chip
      size="small"
      label={`Clients: ${client.name}`}
      disabled
      sx={{ height: "26px", fontSize: "15px", color: "#0a3142" }}
    />
  ) : undefined;

  return (
    <Stack
      sx={{
        // gap: "16px",
        flexGrow: 1,
        // backgroundColor: "white",
        borderRadius: "8px",
        // padding: "22px",
        // boxShadow: "0 1px 2px 0 #1212171a",
        margin: "0 2px 2px 2px",
        overflow: "auto"
      }}
    >
      {/* Filter/query bar — same as Portfolio Analysis, without the portfolio Overview/Classic/Timeline tabs. */}
      <QueryManager
        showFilters
        showTabs={false}
        additionalFilters={clientChip}
        excludeFilters={["client"]}
      />
      {clientId !== undefined && <ClientReportSnapshot clientId={clientId} />}
    </Stack>
  );
};

export default ReportingTab;
